<div class="avatar-container">
  <ngx-avatars
    [name]="name"
    [initialsSize]="3"
    [size]="size"
    bgColor="#bebebe"
    fgColor="#FFFFFF"
  ></ngx-avatars>

  @if (src && (!srcError || fallback !== null) && !fallbackError) {
    <img
      id="avatar"
      [src]="srcError ? fallback : src"
      [width]="size"
      [height]="size"
      (error)="onError($event)"
    />
  }

  @if (badgeSrc) {
    <img id="badge" [src]="badgeSrc" [width]="badgeSize" [height]="badgeSize" />
  }
</div>
